module.exports = __webpack_public_path__ + "img/business-solutions-secondary-hero.66484f3b.png";